import type { PropsWithChildren } from "react";
import { BrowseLevelsLayoutContext } from "#browse-levels-layout-context";
import { useBrowseLevelsLayoutContextValue } from "#browse-levels-layout-context-value";

export function BrowseLevelsLayoutContextProvider({ children }: PropsWithChildren) {
  const value = useBrowseLevelsLayoutContextValue();
  return (
    <BrowseLevelsLayoutContext.Provider value={value}>
      {children}
    </BrowseLevelsLayoutContext.Provider>
  );
}
